import React from "react";

export const CloseIcon = ({ handleClick }) => {
    return <svg className="table__icon-close" onClick={handleClick} xmlns="http://www.w3.org/2000/svg">
        <path d="M3.72827 20.2723L20.2729 3.72768" stroke="#464546" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20.2729 20.2723L3.7283 3.72768" stroke="#464546" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;
};